import React, { Component } from 'react'
import { Form, FormGroup, ControlLabel } from 'react-bootstrap'
import Select from 'react-select'
class EMSelect extends Component {

    constructor(...args) {
      super(...args)
      this.state = {}
      
    }

    onFormChange(e) {
        this.props.onChange(e)
    }

    render() {
        let {formData,schema,uiSchema,required} = this.props
        return(
            <Form>
                <FormGroup>
                    <ControlLabel>{schema.title}{required?<span className='text-red'>*</span>:''}</ControlLabel>
                    <Select
                        clearable={false}
                        value={formData} 
                        onChange={this.onFormChange.bind(this)}
                        options={uiSchema.options}
                    />
                </FormGroup>
            </Form>    
        )
    }    
}    
export default EMSelect


// WEBPACK FOOTER //
// ./src/view/hr/employee/EMSelect.js